
import { Form } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import { CardFooter } from "@/components/ui/card";
import { useForm } from "react-hook-form";
import { ReadingHeader } from "@/components/readings/ReadingHeader";
import { ReadingTypeField } from "@/components/readings/ReadingTypeField";
import { ReadingValueField } from "@/components/readings/ReadingValueField";
import { ReadingDateField } from "@/components/readings/ReadingDateField";
import { ReadingStatus } from "@/components/readings/ReadingStatus";
import { ReadingPhotoUpload } from "@/components/readings/ReadingPhotoUpload";
import { Tables } from "@/integrations/supabase/types";
import { useEffect } from "react";
import { ReadingFormValues } from "./types";

type ReadingWithHouse = Tables<"readings"> & {
  houses: {
    name: string;
  };
};

type ReadingFormProps = {
  reading: ReadingWithHouse;
  onSubmit: (values: ReadingFormValues) => void;
  isSubmitting: boolean;
  selectedFile: File | null;
  setSelectedFile: (file: File | null) => void;
  previewUrl: string | null;
  isUploading: boolean;
  initialDate: Date;
};

export const ReadingForm = ({
  reading,
  onSubmit,
  isSubmitting,
  selectedFile,
  setSelectedFile,
  previewUrl,
  isUploading,
  initialDate
}: ReadingFormProps) => {
  const form = useForm<ReadingFormValues>({
    defaultValues: {
      type: reading.type || "water",
      reading: reading.reading_value ? Number(reading.reading_value) : undefined,
      reading_date: reading.reading_date ? new Date(reading.reading_date) : new Date(),
    },
  });

  // Update form when reading data changes
  useEffect(() => {
    if (reading) {
      form.reset({
        type: reading.type,
        reading: reading.reading_value ? Number(reading.reading_value) : undefined,
        reading_date: reading.reading_date ? new Date(reading.reading_date) : new Date(),
      });
    }
  }, [reading, form]);

  const handleFileSelect = (file: File) => {
    setSelectedFile(file);
    const objectUrl = URL.createObjectURL(file);
    // Let parent component handle the URL state
    return objectUrl;
  };

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
        <div className="space-y-3">
          <ReadingHeader
            type={reading.type}
            houseName={reading.houses.name}
            readingDate=""
            status={reading.status}
          />
          
          <ReadingTypeField control={form.control as any} />
          
          <ReadingValueField control={form.control as any} />
          
          <ReadingDateField control={form.control as any} />
          
          <ReadingPhotoUpload
            previewUrl={previewUrl}
            isUploading={isUploading}
            onFileSelect={handleFileSelect}
          />
          
          <ReadingStatus status={reading.status} />
        </div>

        <CardFooter className="px-0 pt-2">
          <Button 
            type="submit" 
            className="w-full h-10"
            disabled={isUploading || isSubmitting}
          >
            {isSubmitting ? "Guardando..." : "Guardar lectura"}
          </Button>
        </CardFooter>
      </form>
    </Form>
  );
};
